export default __webpack_public_path__ + "static/media/total-orders.a7fa4061.svg";